/**
 * Sends an analytics event to the parent window
 * @param {Object} payload - The analytics payload containing WE and GA data
 * @param {string} [targetOrigin='*'] - The target origin for postMessage (defaults to '*' for development)
 */
export const sendAnalyticsEvent = payload => {
  try {
    let targetOrigin = "*";
    // switch (process.env.REACT_APP_NODE_ENV) {
    //   case "dev":
    //     targetOrigin = "https://dev.yocket.com";
    //     break;
    //   case "alpha":
    //     targetOrigin = "https://alpha.yocket.com";
    //     break;
    //   case "beta":
    //     targetOrigin = "https://beta.yocket.com";
    //     break;
    //   case "production":
    //     targetOrigin = "https://yocket.com";
    //     break;
    //   default:
    // }

    window.parent.postMessage(
      {
        type: "ANALYTIC_EVENT",
        payload: {
          WE: {
            name: payload.WE?.name || "",
            data: payload.WE?.data || {},
          },
          GA: {
            name: payload.GA?.name || "",
            data: payload.GA?.data || {},
          },
        },
      },
      targetOrigin
    );
  } catch (error) {
    console.error("Error sending analytics event:", error);
  }
};
